import { AxiosError, AxiosResponse } from 'axios';
import { IGroups } from '../types/groups-type';
import { Pagination } from '../types/pagination-type';
import { Network } from '../utils/Network';

interface IAdminService {
	getTeamLeader(): Promise<any>;
	exportFilterLead(
		value?: string,
		status?: string,
		dateTo?: string,
		dateFrom?: string,
		agencyId?: string,
	): Promise<AxiosResponse<string, AxiosError>>;
	exportReport(type: string): Promise<AxiosResponse<string, AxiosError>>;
	exportLead(): Promise<AxiosResponse<string, AxiosError>>;
	assignGroupToAgency(uuid: string, group: string): Promise<void>;
	deleteGroupById(id: number): Promise<void>;
	assignGroups(groups: string[], operatorId: number): Promise<void>;
	getPaginatedGroups(arg0: {
		page: number;
		value: string;
		size: number;
	}): Promise<AxiosResponse<Pagination<IGroups[], 'data'>, AxiosError>>;
	createGroups(nome: string): Promise<void>;
	setCredits: (
		uuid: string,
		credit: number,
		numFattura: string,
		creditSms: number,
		isStorno?: boolean,
		noteStorno?: string,
	) => Promise<void>;
	setEnabled: (uuid: string, toggle: boolean, type?: string) => Promise<void>;
}

const AdminService: IAdminService = {
	setCredits: async (uuid, credit, numFattura, creditSms, isStorno, noteStorno) => {
		return Network.post(`/v1/api/agency/${uuid}/credits`, {
			credit,
			numFattura,
			creditSms,
			isStorno,
			noteStorno,
		});
	},
	setEnabled: async (uuid, toggle, type) => {
		return Network.get(`/v1/api/agency/${uuid}/enabled	`, {
			params: {
				toggle,
				type,
			},
		});
	},
	createGroups: async (nome) => {
		return Network.post(`/v1/api/groups`, {
			nome,
		});
	},
	getPaginatedGroups: ({ page, value, size }) =>
		Network.get(`/v1/api/groups`, {
			params: {
				page,
				size,
				value,
			},
		}),
	assignGroups: (groups, operatorId) => {
		return Network.put(`/v1/api/groups/${operatorId}`, {
			groups,
		});
	},
	deleteGroupById: (id) => {
		return Network.delete(`/v1/api/groups/${id}`);
	},
	assignGroupToAgency: (uuid, group) => {
		return Network.put(`/v1/api/agency/${uuid}/group/${group}`);
	},
	exportReport: async (type) => {
		return Network.get(`/v1/api/export/report/${type}`, {
			headers: {
				responseType: 'blob',
			},
		});
	},
	exportLead: async () => {
		return Network.get(`/v1/api/export-leads`, {
			headers: {
				responseType: 'blob',
			},
		});
	},
	exportFilterLead: async (value, status, dateTo, dateFrom, agencyId) => {
		return Network.get(`/v1/api/export-leads-filter`, {
			params: {
				value,
				status,
				dateTo,
				dateFrom,
				agencyId,
			},
			headers: {
				responseType: 'blob',
			},
			timeout: 1000000000,
		});
	},
	getTeamLeader: async () => {
		return Network.get(`/v1/api/agency/team-leader`);
	},
};

export default AdminService;
